<template>
    <admin-layout class="element-edit" v-if="form">

        <app-content-pane class="ml-3">

            <template #title>
                <div class="px-4 pt-3">
                    <h1 class="mb-2">
                        {{ form.title }}
                    </h1>
                    <h6 class="text-muted">
                        <strong>Templates</strong> / {{ form.type }}.{{ form.name }}
                    </h6>
                </div>
                <hr class="mb-0">
            </template>

            <section class="px-3 py-4 form">
                <form action="" @submit.prevent="save()" autocomplete="off">

                    <div class="form-group">
                        <label for="type">Type</label>
                        <select id="type" class="form-control form-control-lg" v-model="form.type">
                            <option value="email">Email</option>
                        </select>
                        <error-line field="type"/>
                    </div>

                    <div class="form-group">
                        <label for="name">Name</label>
                        <input id="name" type="text" class="form-control" v-model="form.name">
                        <error-line field="name"/>
                    </div>

                    <hr class="my-4" />

                    <div class="form-group">
                        <label for="title">Title</label>
                        <input id="title" type="text" class="form-control" v-model="form.title">
                        <error-line field="title"/>
                    </div>

                    <div class="form-group">
                        <div class="d-flex">
                            <label for="content" class="mr-3">Content</label>
                            <a class="ml-auto"
                               href="https://www.markdownguide.org/basic-syntax/"
                               target="_blank">Markdown Supported</a>
                        </div>
                        <textarea id="content" class="form-control" v-model="form.content" />
                        <error-line field="content"/>
                    </div>

                    <hr class="my-4">

                    <div class="form-group">
                        <button class="btn btn-primary"
                                type="submit">Save</button>
                    </div>

                </form>
            </section>


        </app-content-pane>
    </admin-layout>
</template>

<script>
import AdminLayout from "@/Layouts/AdminLayout";
import AppContentPane from "@/Components/AppContentPane";
import ErrorLine from "@/Components/Common/ErrorLine";
import FileUploader from "@/Components/Common/FileUploader";
import uploads from "@/mixins/uploads";
import utils from "@/mixins/utils";
import EditableText from "@/Components/Common/EditableText";

export default {
    name: "Edit",
    components: {EditableText, AdminLayout, AppContentPane, ErrorLine, FileUploader},
    props: ['template'],
    mixins: [uploads, utils],

    data(){
        return {
            is_busy: false,
            form: null,
        }
    },

    computed: {
    },

    methods:{

        save(){

            this.is_busy = true;

            if( this.template ){
                this.form
                    .put(this.route('message-template.update', {
                        message_template: this.template.id,
                        ...this.global_url_params
                    }, {
                        onFinish: (res) => {
                            console.log({res});
                        }
                    }));
            } else {
                this.form.post(this.route('message-template.store', {
                    ...this.global_url_params
                }));
            }

        },
    },

    mounted() {

        if( this.template ){
            this.form = this.$inertia.form({
                name: this.template.name,
                type: this.template.type,
                title: this.template.title,
                content: this.template.content,
            });
        }else{
            this.form = this.$inertia.form({
                name: 'unnamed.template',
                type: 'email',
                title: 'Unnamed Template',
                content: '',
            });
        }


        if( this.template ){
            this.setTitle( `Edit "${this.template.type}.${this.template.name}" Template` );
        }else{
            this.setTitle( `Create Template` );
        }

    }


}
</script>

<style lang="scss" scoped>
.preview{
    display: block;
    margin: 0.6rem 0;
    width: 260px;
    height: 260px;
    object-fit: cover;
}
.form{
    max-width: 800px;
}

textarea{
    min-height: 240px;
}
</style>
